/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to create a new custom tag
 * @export
 * @interface CreateTagNoteCommand
 */
export interface CreateTagNoteCommand {
    /**
     * Label of the tag
     * @type {string}
     * @memberof CreateTagNoteCommand
     */
    label: string;
    /**
     * Color code for the tag (hex format)
     * @type {string}
     * @memberof CreateTagNoteCommand
     */
    color: string;
}

/**
 * Check if a given object implements the CreateTagNoteCommand interface.
 */
export function instanceOfCreateTagNoteCommand(value: object): value is CreateTagNoteCommand {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function CreateTagNoteCommandFromJSON(json: any): CreateTagNoteCommand {
    return CreateTagNoteCommandFromJSONTyped(json, false);
}

export function CreateTagNoteCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTagNoteCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'color': json['color'],
    };
}

export function CreateTagNoteCommandToJSON(json: any): CreateTagNoteCommand {
    return CreateTagNoteCommandToJSONTyped(json, false);
}

export function CreateTagNoteCommandToJSONTyped(value?: CreateTagNoteCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'color': value['color'],
    };
}

